import { createElementBlock, openBlock, renderSlot } from 'vue';
/* empty css                        */
import _export_sfc from './basler-components.es299.js';

const _sfc_main = {};

const _hoisted_1 = { class: "product-list-pagination" };

function _sfc_render(_ctx, _cache) {
  return (openBlock(), createElementBlock("div", _hoisted_1, [
    renderSlot(_ctx.$slots, "default")
  ]))
}
const ProductListPagination = /*#__PURE__*/_export_sfc(_sfc_main, [['render',_sfc_render]]);

export { ProductListPagination as default };
